let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kvlvl")).then(() => parcelRequire('1sa5w'));